module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {

	fox.registerWidget('ClientLSGoal', {

		configure: function () {
			this.goalText = false;
			this.previosGoal = false;

			this.registerOptions('', {
				'embed.container': '#liveshow-goal-container',
				template: 'liveshow_viewer_goal',
				autoRender: true
			});

			this.callParent('configure', arguments);
		},

		setGoal: function (text) {
			this.previosGoal = this.goalText;
			this.goalText = text;

			this.render();
		},

		unsetGoal: function () {
			this.goalText = false;

			if (this.isEmbedded()) {
				this.removeFromDom();
			}
		},

		rendering: function() {
			this.setTemplateOptions('goalText', this.goalText);

			this.callParent('rendering', arguments);
		},

		beforeEmbed: function () {
			if (this.goalText) {
				this.callParent('beforeEmbed', arguments);
			} else if (!this.goalText && this.previosGoal) {
				this.removeFromDom();
			}
		},

		deactivate: function() {
			this.callParent('deactivate', arguments);

			this.unsetGoal();
		}
	}, 'Widget');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/liveshow/widget/ClientLSGoal.js
// module id = 561
// module chunks = 4